<template>
    <div>
        <b-card no-body>
            <b-card-header>
                <h5>
                    {{ tipoPesquisa }}
                    <app-btn-voltar
                        class="float-right ml-2"
                        rota="Home"
                        variant="secondary"
                    ></app-btn-voltar>
                    <enviar
                        v-if="perguntas.length > 0"
                        :perguntas="perguntas"
                        :pesquisa="tipoPesquisa"
                    ></enviar>
                </h5>
            </b-card-header>
            <b-card-body>
                <b-row>
                    <b-col
                        sm="12"
                        v-for="pergunta in perguntas"
                        :key="pergunta.perguntaId"
                    >
                        <h4>
                            <strong>{{ pergunta.pergunta }}</strong>
                        </h4>
                        <b-form-group>
                            <ckeditor
                                :editor="editor"
                                v-model="pergunta.resposta"
                                :config="editorConfig"
                            ></ckeditor>
                        </b-form-group>
                    </b-col>
                </b-row>
            </b-card-body>
        </b-card>
    </div>
</template>

<script>
import ClassicEditor from '@ckeditor/ckeditor5-build-classic'
import '@ckeditor/ckeditor5-build-classic/build/translations/pt-br'
import PesquisasServicos from './PesquisasServicos'
import Enviar from './Enviar'

export default {
    components: {
        Enviar
    },

    data() {
        return {
            perguntas: [],
            editor: ClassicEditor,
            editorConfig: {
                language: 'pt-br',
                toolbar: [
                    'bold',
                    'italic',
                    'link',
                    '|',
                    'bulletedList',
                    'numberedList',
                    'blockQuote',
                    '|',
                    'insertTable',
                    '|',
                    'mediaEmbed',
                    '|',
                    'undo',
                    'redo'
                ]
            }
        }
    },

    methods: {
        obterPerguntas() {
            this.$store.dispatch('addRequest')
            PesquisasServicos.obterPerguntas(
                this.$route.params.pesquisaId
            ).then(response => {
                if (response) {
                    if (response.success) {
                        this.perguntas = response.data
                    } else {
                        this.$toast.error(
                            'Erro ao obter a pesquisa',
                            'ERROR',
                            this.$toastConfig.error
                        )
                    }
                }
                this.$store.dispatch('removeRequest')
            })
        }
    },

    created() {
        this.obterPerguntas()
    },

    computed: {
        tipoPesquisa() {
            return this.perguntas.length > 0 ? this.perguntas[0].pesquisa : ''
        }
    }
}
</script>

<style>
.ck-editor__editable_inline {
    min-height: 100px;
}
</style>
